import { apiClient } from '../../app/api';
import type { CategoryUpsertRequest, CategoryView } from './types';

export function listCategories(): Promise<CategoryView[]> {
  return apiClient.get<CategoryView[]>('/operator/categories');
}

export function createCategory(payload: CategoryUpsertRequest): Promise<CategoryView> {
  return apiClient.post<CategoryView>('/operator/categories', payload);
}

export function updateCategory(
  id: number,
  payload: CategoryUpsertRequest,
): Promise<CategoryView> {
  return apiClient.put<CategoryView>(`/operator/categories/${id}`, payload);
}

export function deleteCategory(id: number): Promise<void> {
  return apiClient.delete<void>(`/operator/categories/${id}`);
}
